import React from 'react';
import PropTypes from 'prop-types';
import generate from 'shortid';

import { GREEN_LIGHT, WHITE } from '../../styles/shared/colors';
import arrow from "../../assets/imgs/dropDown-arrow.png";
import "./InfoTable.scss";

const InfoTable = ({ 
  children, 
  headers, 
  onChildClick, 
  gridTemplateColumns, 
  onHeaderClick, 
  isDesc, 
  sortedBy,
}) => {
  return (
    <div className="info-table">
      <div className="info-table__header" style={{ gridTemplateColumns: gridTemplateColumns || "inherit" }}>
        {headers.map(header => 
          <span key={generate()} className="info-table__header__title">
            <button type="button" onClick={()=> onHeaderClick(header)}>
              {header}
              {header && header === sortedBy &&
                <img style={{ paddingLeft: "3px",  transform: `rotateZ(${isDesc ? '180' : '0'}deg)` }} src={arrow} alt="" />
              }
            </button>
          </span>
        )}
      </div>
      <div className="info-table__body">
        {children.map((child, i) =>
          <button
            key={generate()}
            className="info-table__body__button"
            type="button"
            style={{
              backgroundColor: i % 2 === 0 ? "#302E30" : "#202020",
            }}
            onClick={()=> onChildClick(child.props)}
          >
            <div
              className="info-table__body__button__child"
              style={{
                gridTemplateColumns: gridTemplateColumns || "inherit", 
                color: child.props.isSelected ? GREEN_LIGHT : WHITE
              }}
            >
              {child}
            </div>
          </button>
        )}
      </div>
    </div>
  );
};

InfoTable.propTypes = {
  children: PropTypes.array, 
  gridTemplateColumns: PropTypes.string,
  headers: PropTypes.array, 
  isDesc: PropTypes.bool,
  onChildClick: PropTypes.func,
  onHeaderClick: PropTypes.func, 
  sortedBy: PropTypes.string 
};

InfoTable.defaultProps = {
  children: [], 
  gridTemplateColumns: "",
  headers: [], 
  isDesc: false, 
  onChildClick: ()=> {},
  onHeaderClick: ()=> {}, 
  sortedBy: "" 
};

export default InfoTable;
